// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".category-table .title {\n  color: #606266;\n  font-size: 13px;\n  margin-bottom: 8px;\n  line-height: 1.3;\n  font-weight: bold;\n}\n.category-type {\n  display: flex;\n  align-items: center;\n  height: 32px;\n}", ""]);
// Exports
module.exports = exports;
